module.exports = __webpack_public_path__ + "static/img/icon.88e3e59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/icon.jpg
// module id = MSnw
// module chunks = 0